<template>
  <div>
    <MerchantCompaniesList />
  </div>
</template>

<script>
import MerchantCompaniesList from "../components/MerchantCompaniesList.vue";
export default {
  components: {
    MerchantCompaniesList,
  },

};
</script>

